import React, { FC } from "react";
import { Platform, View } from "react-native";
import variables from "../../../styles/variables";
import { HeroBackgroundWrapper } from "../../Hero/Hero";
import HomepageLayout from "../../Layout/HompageLayout";
import AdProvider from "../../Advertiser/AdProvider";
import { useAtom } from "jotai";
import { pageDataAtom } from "../../../atoms";
import UseAutoMetaTags from "../../../hooks/UseAutoMetaTags";
import StructuredData from "../../SEO/StructuredData";
import { ContentSections } from "../../../components/Screens/Members/components/ContentSections";
import Gap from "../../Gap";
import { pageDataStatus } from "../../../utils/pageDataStatus";
import { HeaderAdvert } from "../../Layout/HeaderAdvert";

const Home: FC = () => {
  const [pageData] = useAtom(pageDataAtom);

  UseAutoMetaTags({
    page: "Home",
  });

  return (
    <HomepageLayout
      content={
        <>
          <HeroBackgroundWrapper />
          <View
            style={{
              paddingHorizontal: variables.spacing.xsmall,
              backgroundColor: variables.colors.palette.rtv.primary,
            }}
          >
            <HeaderAdvert gap />
            <AdProvider priority={5} gap>
              {/* looping through content sections means no changes required to Ad provider as each
              section is treated as a child instead of all sections being one child
              */}
              {pageDataStatus(pageData) === "valid" &&
              !!pageData?.page?.content_sections?.length
                ? pageData.page?.content_sections.map((section, index) => (
                    <ContentSections
                      key={index}
                      sections={[section]}
                      loadingOverride={pageDataStatus(pageData) === "loading"}
                    />
                  ))
                : null}
              <Gap size="small" vertical />
              {Platform.OS == "web" && (
                <StructuredData
                  type="Organization"
                  data={{
                    "@type": "Organization",
                    name: "Racing TV",
                    url: "https://www.racingtv.com",
                    sameAs: [
                      "https://www.facebook.com/racingtv",
                      "https://twitter.com/RacingTV",
                      "https://www.instagram.com/RacingTV",
                      "https://www.youtube.com/racingtv",
                      "https://www.tiktok.com/@racing_tv",
                    ],
                    address: {
                      "@type": "PostalAddress",
                      streetAddress: "10th Floor, Met Building, 22 Percy St",
                      addressRegion: "London",
                      postalCode: "W1T 2BU",
                      addressCountry: "UK",
                    },
                    telephone: "0844 855 1881",
                    logo: window.location.host + "/favicon-32.webp",
                  }}
                />
              )}
            </AdProvider>
          </View>
        </>
      }
    />
  );
};

export default Home;
